import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const action = (state: IState, action: PayloadAction<boolean>) => {
  state.filter.data.hasActions = action.payload;
};

export default action;
